import { MachineConfig } from 'xstate/lib/types';
import {
  SIGN_UP_FLOW_STATES_NAME,
  SignUpFlowContext,
  SignUpFlowStatesSchema,
} from './signUpMachineTypes';
import { SignUpFlowEvents } from './signUpMachineEventTypes';
import {
  welcomeState,
  redirectState,
  initState,
  billingState,
} from './signUpMachineStates';

export const signUpFlowMachineConfig: MachineConfig<
  SignUpFlowContext,
  SignUpFlowStatesSchema,
  SignUpFlowEvents
> = {
  id: 'SignUpFlow',
  initial: SIGN_UP_FLOW_STATES_NAME.INIT,
  context: {
    activeStep: 0,
    stepOptions: {
      isOtherIndustrySelected: false,
    },
  },
  states: {
    [SIGN_UP_FLOW_STATES_NAME.INIT]: initState,
    [SIGN_UP_FLOW_STATES_NAME.WELCOME]: welcomeState,
    [SIGN_UP_FLOW_STATES_NAME.BILLING]: billingState,
    [SIGN_UP_FLOW_STATES_NAME.REDIRECT]: redirectState,
  },
};
